import { defineStore } from 'pinia';
import axios from 'axios';
import * as Sentry from '@sentry/vue';

const apiClient = axios.create({
    baseURL: '/',
    withCredentials: true, // required to handle the CSRF token
});

// eslint-disable-next-line import/prefer-default-export
export const useAuthStore = defineStore('auth', {
    state: () => ({
        loading: false,
        user: 0,
    }),
    actions: {
        async getAuthUser() {
            this.loading = true;
            try {
                const response = await apiClient.get('/vue/users/auth');
                this.user = response.data.data;
                Sentry.setUser({ id: response.data.data.id });
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
            this.loading = false;
        },
        resetAndRedirect() {
            Sentry.setUser(null);
            this.user = null;
            window.location.reload();
        },
    },
});
